import * as React from "react";
const SvgFiRrThunderstorm = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-thunderstorm_svg__a)">
      <path
        fill="#062147"
        d="M10.892 24.015a1.9 1.9 0 0 1-.815-.186 1.844 1.844 0 0 1-1-2.207L9.614 20H7.923a1.933 1.933 0 0 1-1.84-2.48l2.132-6.173A2 2 0 0 1 10.1 10H12a2 2 0 0 1 1.867 2.717L13.413 14h1.68a1.905 1.905 0 0 1 1.588 2.958L12.419 23.2a1.85 1.85 0 0 1-1.527.815M11 18a1 1 0 0 1 .949 1.315l-.662 1.993 3.66-5.357L12 16a1 1 0 0 1-.943-1.333l.932-2.642-1.89-.025-2.078 6.03zm8 1.5a1 1 0 0 1-.385-1.923c4.967-2.007 4.218-9.468-1.032-10.472a3.01 3.01 0 0 1-2.158-1.672 6 6 0 0 0-11.34 1.534 6.2 6.2 0 0 0 .024 2.18 3 3 0 0 1-.962 2.762 3.522 3.522 0 0 0 .41 5.5 1 1 0 1 1-1.114 1.662A5.536 5.536 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.89A7.95 7.95 0 0 1 8.5.138a8.06 8.06 0 0 1 8.734 4.44 1.04 1.04 0 0 0 .743.569c7.187 1.424 8.193 11.483 1.41 14.278A1 1 0 0 1 19 19.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-thunderstorm_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrThunderstorm;
